import React from "react";
import { ReactComponent as MATERIAL } from "../img/skill_icons/material.svg";

export const Material = () => {
  return <MATERIAL title="material design" />;
};
